import { render } from "./register.vue?vue&type=template&id=31317bcf&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"

import "./register.vue?vue&type=style&index=0&id=31317bcf&lang=less&scoped=true"

import exportComponent from "F:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31317bcf"]])

export default __exports__